var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"app-content content"},[_c('div',{staticClass:"content-overlay"}),_vm._v(" "),_c('div',{staticClass:"header-navbar-shadow"}),_vm._v(" "),_c('div',{staticClass:"content-wrapper p-0"},[_c('router-view',{key:_vm.project.id,attrs:{"project":_vm.project}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }